import React from 'react';
import {
  createSocialLoginState,
  rememberSocialLoginFlow,
  resolveSocialLoginSource,
} from './SocialLoginUtils.js';

const KAKAO_CLIENT_ID = "09d2dd9dab520015f26cf11a0ecfb3c3"

const KakaoLogin = ({ successCallback, failCallback, source }) => {
  const login = () => {
    const resolvedSource = resolveSocialLoginSource(source)
    const state = createSocialLoginState({
      successCallback,
      failCallback,
      source: resolvedSource,
    })
    const redirectUri = encodeURIComponent(window.location.origin + `/auth/callback/kakao`)

    rememberSocialLoginFlow(state, {
      successCallback,
      failCallback,
      source: resolvedSource,
    })

    window.location.href = `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${KAKAO_CLIENT_ID}&redirect_uri=${redirectUri}&state=${state}`
  }

  return (
    <button type='button' className='social-login-button social-login-button--kakao' onClick={login}>
      <span className='social-login-icon' aria-hidden='true'><img src='/image/kakao-talk.svg' alt='' /></span>
      <span>카카오로 시작하기</span>
      <span className='social-login-arrow' aria-hidden='true'>›</span>
    </button>
  )
}

export default KakaoLogin
